import React, {useContext} from 'react';
import EditRecur from './EditRecur'
import { LegacyStack} from '@shopify/polaris';
import { UserContext } from '../../contexts/User'
import {formatDate} from '../../DateUtil'

export default function RecurInfo(props) {
  const user = useContext(UserContext)

  const recur = props.recur
  const subscription = props.subscription

  const isStudent = subscription.isStudent(user)

  return <LegacyStack spacing="tight">
    <LegacyStack.Item>{`Monthly subscription ${recur && recur.status != 'ACTIVE' ? `(${recur.status})` : ''}`}</LegacyStack.Item>
    {
      recur && recur.status == 'CANCELLED' && subscription.isActive ?
      <LegacyStack.Item>{`Ends on ${formatDate(subscription.endAt)}`}</LegacyStack.Item> : null
    }
    {
      recur && recur.status == 'PAUSED' && subscription.isActive ?
      <LegacyStack.Item>{`Access until ${formatDate(subscription.endAt)}`}</LegacyStack.Item> : null
    }
    { !isStudent ? <LegacyStack.Item>
      <EditRecur orderId={subscription.orderId} properties={subscription.properties} recur={recur} />
      </LegacyStack.Item> : null }
  </LegacyStack>
}
